<template>
    <div class="main">
        <van-form @submit="onSubmit" style="margin: 12px 12px 0 12px;">
            <van-field v-model="form.Car" label="班车" readonly />
            <van-field v-model="form.UserId" label="工号" readonly />
            <van-field v-model="form.Name" label="姓名" readonly />
            <!-- <van-field v-model="form.Phone" label="手机号码" readonly /> -->
            <van-field v-model="form.DateTime" label="日期" readonly />
            <van-field
                v-model="form.BoardingPoint"
                is-link
                readonly
                :label="form.Car === '园区线' ? '上车点' : (form.Type === '上班' ? '上车点' : '下车点')"
                :placeholder="form.Car === '园区线' ? '请选择上车点' : (form.Type === '上班' ? '请选择上车点' : '请选择下车点')"
                @click="showBoardingPointPicker = true"
                required
            />
            <van-popup v-model="showBoardingPointPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="boardingPointOptions"
                    @confirm="onBoardingPointConfirm"
                    @cancel="showBoardingPointPicker = false"
                />
            </van-popup>
            <baidu-map class="map" center="珠海市">
                <bm-geolocation
                    anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                    :showAddressBar="true" 
                    :autoLocation="true"
                    @locationSuccess="locationSuccess"></bm-geolocation>
            </baidu-map>
            <div style="margin: 20px 16px 0 16px;">
                <van-button round block type="info" native-type="submit" :disabled="btn" :loading="lod">{{btnText}}</van-button>
            </div>
        </van-form>
    </div>
</template>
<script src="https://unpkg.com/vue-baidu-map"></script>
<script>
    // import wx from 'weixin-js-sdk'
    export default {
        data() {
            return {
                WXInfo: {},
                form: {
                    Name: '',
                    LatLng: {},
                    BoardingPoint: ''
                },
                lod: false,
                btn: false,
                btnText: '提 交',
                showBoardingPointPicker: false,
                boardingPointOptions: [],
                // 班车线路站点配置
                busRoutes: {
                    'A线': {
                        '上班': [
                            '隧道南', '银石雅园', '前山西门', '翠景工业区', '招商花园城', 
                            '新香洲万家', '体育中心西', '香山湖公园', '健民路北', 
                            '凤凰山遂道', '官塘', '健帆园区（1号门）'
                        ],
                        '下班': [
                            '健帆园区（1号门）', '官塘', '凤凰山遂道', '健民路北', 
                            '香山湖公园', '体育中心西', '新香洲万家', '招商花园城', 
                            '翠景工业区', '明珠商业广场', '前山西门', '银石雅园', '隧道南'
                        ]
                    },
                    'B线': {
                        '上班': [
                            '中大南门', '鸡山', '白浦路口', '唐家', '唐家市场', 
                            '港湾一号', '海怡湾畔', '白沙（魅族）', '国际赛车场', 
                            '官塘', '健帆园区（1号门）', '健帆园区（千帆公寓）', 
                            '金鼎市场', '金鼎园区'
                        ],
                        '下班': [
                            '健帆园区（1号门）', '国际赛车场', '白沙（魅族）', 
                            '海怡湾畔', '唐家市场', '唐家', '白浦路口', '中大南门', 
                            '银坑', '华子石东', '香洲总站', '优特汇', '名街花园', '金桦花园'
                        ]
                    },
                    'C线': {
                        '上班': [
                            '南坑', '华子石东', '鸡山', '唐家', '港湾一号', 
                            '白沙（魅族）', '国际赛车场', '健帆园区（1号门）'
                        ],
                        '下班': [
                            '健帆园区（1号门）', '国际赛车场', '白沙（魅族）', 
                            '港湾一号', '唐家', '鸡山', '银坑', '华子石东', '南坑', '香洲总站'
                        ]
                    },
                    '园区线': [
                        '健帆园区（千帆公寓）', '金鼎园区', '健帆园区（1号门）'
                    ]
                }
            }
        },
        // async created() {
        //     let wxJs = document.createElement("script")
        //     wxJs.type = "text/javascript"
        //     wxJs.src = "https://res.wx.qq.com/open/js/jweixin-1.2.0.js"
        //     wxJs.onload = await this.getWXSign()
        //     document.head.appendChild(wxJs)
        // },  
        mounted() {
            // const test = { "errno": 0, "data": { "errcode": 0, "errmsg": "ok", "userid": "2017551", "name": "吴昌悦", "department": [2267], "position": "软件开发工程师", "mobile": "15812615614", "gender": "1", "email": "wuchangyue@jianlianmed.com", "avatar": "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0", "status": 1, "isleader": 0, "extattr": { "attrs": [{ "name": "英文名", "value": "", "type": 0, "text": { "value": "" } }, { "name": "工号", "value": "2017551", "type": 0, "text": { "value": "2017551" } }, { "name": "身份证", "value": "", "type": 0, "text": { "value": "" } }] }, "english_name": "", "telephone": "020-88985632", "enable": 1, "hide_mobile": 0, "order": [0], "external_profile": { "external_attr": [], "external_corp_name": "" }, "main_department": 2267, "qr_code": "https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c", "alias": "", "is_leader_in_dept": [0], "address": "", "thumb_avatar": "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100", "direct_leader": [], "openid": "o_Td1s7gCLuLiZITNxC3ApjOLC7U", "access_token": "hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w" } }
            // this.WXInfo = test.data
            this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
            this.form.Name = this.WXInfo.name
            this.form.UserId = this.WXInfo.userid
            this.form.Phone = this.WXInfo.mobile
            this.form.DateTime = this.$moment().format('YYYY-MM-DD')
            this.form.OpenId = this.WXInfo.openid
            this.form.Car = this.$route.query.Car
            this.form.Type = this.getType()
            
            // 设置上车点选项
            this.setBoardingPointOptions()
            
            this.getQRcodeData()
        },
        methods: {
            locationSuccess(val) {
                this.form.Address = val.addressComponent.province + val.addressComponent.city + val.addressComponent.district + val.addressComponent.street + val.addressComponent.streetNumber
                this.form.LatLng = { Lat: val.point.lat, Lng: val.point.lng }
            },
            getType() {
                // 根据当前时间判断是上班还是下班
                // 早上8点30分之前为上班
                // 下午17点30分之后为下班
                let time = this.$moment().format('HH:mm')
                console.log('time', time)
                let type = ''
                if (time < '08:30') {
                    type = '上班'
                } else if (time > '17:30') {
                    type = '下班'
                } else {
                    this.$toast('请在8:30之前或17:30之后提交数据。')
                    this.$router.push('/QRcode/error')
                }
                return type
            },
            setBoardingPointOptions() {
                // 根据班车线路和类型设置上车点选项
                const carLine = this.form.Car
                const type = this.form.Type
                
                if (carLine === '园区线') {
                    // 园区线没有上下班区分，直接使用园区线的站点
                    this.boardingPointOptions = this.busRoutes[carLine] || []
                } else if (carLine && type && this.busRoutes[carLine] && this.busRoutes[carLine][type]) {
                    // 其他线路根据上下班类型设置站点
                    this.boardingPointOptions = this.busRoutes[carLine][type]
                } else {
                    this.boardingPointOptions = []
                }
            },
            onBoardingPointConfirm(value) {
                this.form.BoardingPoint = value
                this.showBoardingPointPicker = false
            },
            onSubmit() {
                // 验证上车点/下车点是否已选择
                if (!this.form.BoardingPoint) {
                    this.$toast(this.form.Car === '园区线' ? '请选择上车点' : (this.form.Type === '上班' ? '请选择上车点' : '请选择下车点'))
                    return
                }
                
                if (this.form.Address) {
                    this.lod = true
                    this.postQRcodeData(this.form)
                } else {
                    this.$toast('请先点击地图上定位按钮，在提交数据。')
                }
                // wx.openLocation({
                //     latitude: this.form.Lat, // 纬度，浮点数，范围为90 ~ -90
                //     longitude: this.form.Lng, // 经度，浮点数，范围为180 ~ -180。
                //     name: '', // 位置名
                //     address: '', // 地址详情说明
                //     scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为16
                // });
            },
            // Location() {
            //     // this.form.Lat = 22.394577026367188 // 纬度，浮点数，范围为90 ~ -90
            //     // this.form.Lng = 113.54364013671875
            //     // this.form.LatLng = { lng: this.form.Lng, lat: this.form.Lat } latitude":22.26666,"longitude":113.54342
            //     let that = this
            //     wx.ready(function(){
            //         wx.getLocation({
            //             type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            //             success: function (res) {
            //                 that.form.Lat = res.latitude // 纬度，浮点数，范围为90 ~ -90
            //                 that.form.Lng = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            //                 // var speed = res.speed; // 速度，以米/每秒计
            //                 // var accuracy = res.accuracy; // 位置精度
            //                 console.log('location', res)
            //                 // console.log(this.form)
            //                 that.form.LatLng = { lng: that.form.Lng, lat: that.form.Lat }
            //                 // Object.assign(this.form.LatLng, { lng: this.form.Lng, lat: this.form.Lat })
            //             }
            //         })
            //         // console.log('123', this.form)
            //     })
            // },
            // async getWXSign() {
            //     const result = await this.$request({
            //         method: 'GET',
            //         url: this.$api.getWXSign,
            //         params: {
            //             Url: window.location.href
            //         }
            //     })
            //     if (result.success) {
            //         let data = result.data
            //         wx.config({
            //             beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            //             debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            //             appId: 'wxdf5df2adda0272b2', // 必填，公众号的唯一标识
            //             timestamp: data.timestamp, // 必填，生成签名的时间戳
            //             nonceStr: data.noncestr, // 必填，生成签名的随机串
            //             signature: data.signature,// 必填，签名
            //             jsApiList: ['openLocation', 'getLocation', 'closeWindow'] // 必填，需要使用的JS接口列表
            //         })
            //     }
            // } 
            async getQRcodeData() {
                const result = await this.$request({
                    url: this.$api.getFunctionByQuery,
                    method: 'GET',
                    params: {
                        Model: 'busdata',
                        Type: this.form.Type,
                        UserId: this.form.UserId,
                        DateTime: this.$moment().format('YYYY-MM-DD')
                    }
                })
                if (result.success) {
                    this.btn = true
                    this.btnText = '数据已提交'
                    this.$router.push('/QRcode/success')
                }
            },
            async postQRcodeData(data) {
                const result = await this.$request({
                    url: this.$api.postQRcodeData,
                    method: 'POST',
                    params: {
                        Type: this.form.Type,
                        UserId: this.form.UserId,
                        DateTime: this.$moment().format('YYYY-MM-DD')
                    },
                    data
                })
                if (result.success) {
                    this.btn = true
                    this.btnText = '数据已提交'
                    this.lod = false
                    this.$router.push('/QRcode/success')
                } else {
                    this.lod = false
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .main {
        /* height: 100%; */
        /* margin: 10% 12px; */
        overflow: hidden;
    }
    .map {
        width: 100%;
        height: 200px;
        margin-top: 8px;
    }
</style>